import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import Sidebar from './Sidebar';
import { Session } from "./utils/session";
import { useNavigate } from "react-router-dom";
import BoardDetails from "./BoardDetails";
import { API_BASE_URL } from '../config';




export default function DailyTask() {
  const [selectedBoard, setSelectedBoard] = useState(null);
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const [hideDesktop, setHideDesktop] = useState(false);
  const [boardData, setBoardData] = useState({ tasks: {}, columns: {}, columnOrder: [] });
  const [selectedTask, setSelectedTask] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editedContent, setEditedContent] = useState('');
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [taskToDelete, setTaskToDelete] = useState(null);
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState('');
  const [taskSearch, setTaskSearch] = useState('');
  const [priorities, setPriorities] = useState([]);
  const [filterPriorityId, setFilterPriorityId] = useState('');
  const [boardList, setBoardList] = useState([]);
  const [boardListError, setBoardListError] = useState(null);
  const [boardLists, setBoardLists] = useState([]);
  const [listsLoading, setListsLoading] = useState(false);
  const [listsError, setListsError] = useState(null);
  const navigate = useNavigate();
  const [selectedBoardId, setSelectedBoardId] = useState(null);
  const [selectedBoardName, setSelectedBoardName] = useState("");
  const role = Session.getRole();
  const isMember = role === "Member";
  const token = Session.getToken();
  const currentUserId = Session.getUserId();
  const currentUser = Session.getUser && typeof Session.getUser === 'function' ? Session.getUser() : null;

  useEffect(() => {
      if (!token) return;
      if (role && role.toLowerCase() === 'super admin') {
        fetch(`${API_BASE_URL}/api/Workspace/BoardList`, {
          headers: { Authorization: `Bearer ${token}` },
        })
          .then(async res => {
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            try {
              return await res.json();
            } catch {
              return [];
            }
          })
          .then(data => setBoardList(data || []))
          .catch(err => setBoardListError(err.message || 'Failed to load board list'));
      } else if (currentUserId && !isNaN(Number(currentUserId)) && Number(currentUserId) > 0) {
        fetch(`${API_BASE_URL}/api/Workspace/Board/${currentUserId}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
          .then(async res => {
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            try {
              const json = await res.json();
              return json.data || [];
            } catch {
              return [];
            }
          })
          .then(data => setBoardList(data || []))
          .catch(err => setBoardListError(err.message || 'Failed to load board list'));
      } else {
        setBoardListError('User not found or invalid. Please login again.');
        setBoardList([]);
      }
    }, [token, currentUserId, role]);
    console.log('boardList:', boardList);
  
  // Filter unique boards by boardName (or boardID if preferred)
  const uniqueBoards = [];
  const seenNames = new Set();
  for (const board of boardList) {
    if (!seenNames.has(board.boardName)) {
      uniqueBoards.push(board);
      seenNames.add(board.boardName);
    }
  }

  return (
    <div style={{ background: '#f6f8fa', minHeight: '100vh', padding: '32px 0' }}>
      <div
        className="main-card mt-4"
        style={{
          margin: '0 auto',
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
          border: 'none',
          marginLeft: '283px',
        }}
      >
        <h2 style={{ fontWeight: 700, marginBottom: 24, color: '#222', letterSpacing: 1 }}>Trello Boards</h2>
        {boardListError && <div className="alert alert-danger" style={{ marginBottom: 24 }}>{boardListError}</div>}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '24px', justifyContent: 'start' }}>
          {uniqueBoards.length === 0 && !boardListError && (
            <div style={{ color: '#888', fontSize: 18, marginTop: 32 }}>No boards available.</div>
          )}
          {uniqueBoards.map(board => (
            <div
              key={board.boardID}
              style={{
                background: '#fff',
                border: '1px solid #e3e6ea',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                padding: '24px 20px 16px 20px',
                minWidth: '260px',
                maxWidth: '320px',
                flex: '1 1 260px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
                transition: 'box-shadow 0.2s',
                cursor: 'pointer',
                marginBottom: '0',
              }}
              onClick={() => {
                setSelectedBoardId(board.boardID);
                setSelectedBoardName(board.boardName);
              }}
            >
              <div
                style={{ fontWeight: 600, marginBottom: 12, color: '#0079bf', fontSize: 20, textDecoration: 'underline', textAlign: 'center' }}
              >
                {board.boardName}
              </div>
            </div>
          ))}
          {/* BoardDetails below all boards */}
          {selectedBoardId && (
            <div style={{ width: '100%', margin: '24px 0' }}>
              <BoardDetails boardId={selectedBoardId} boardName={selectedBoardName} isModal={false} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
